import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ChangeEvent } from 'react';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';

interface IHandlingAndStorage {
  handlingAndStorage?: string;
  storage?: string;
  disposalConsiderations?: string;
  specificEndUse?: string;
  expanded: boolean;
  handleChange: (
    panel: string
  ) => ((event: ChangeEvent<{}>, expanded: boolean) => void) | undefined;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      display: 'flex',
      flexDirection: 'column',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '80%',
      flexShrink: 0,
    },
  })
);

const HandlingAndStorage: React.FC<IHandlingAndStorage> = ({
  handlingAndStorage,
  storage,
  disposalConsiderations,
  specificEndUse,
  expanded,
  handleChange,
}): JSX.Element => {
  const { t } = useTranslation();
  const classes = useStyles({});

  return (
    <Accordion
      expanded={expanded}
      onChange={handleChange(`panel5`)}
      key={'panel5'}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel5bh-content`}
        id={`panel5bh-header`}
      >
        <Typography className={classes.heading}>{t('chemicals.handling.and.storage')}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.list}>
        {handlingAndStorage && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.handling_and_storage')}</b> ${handlingAndStorage}` }} />
        )}
        {storage && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.storage')}</b> ${storage}` }} />
        )}
        {specificEndUse && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.specific_end_use')}</b> ${specificEndUse}` }} />
        )}
        {disposalConsiderations && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.disposal_considerations')}</b> ${disposalConsiderations}` }} />
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default HandlingAndStorage;
